import React from "react";

const items = [
    {
        text: "Dashboard",
        link: "/dashboard",
        icon: "assessment",
        permissions: ["admin", "staf"]
    },
    {
        text: "Tenants",
        icon: "business",
        permissions: ["admin", "staf"],
        children: [
            {
                text: "Tenant",
                link: "/tenant/list",
                permissions: ["admin", "staf"]
            },
            {
                text: "Request Tenant",
                link: "/tenant/request-tenant",
                permissions: ["admin"]
            },
            // {
            //     text: "Tenant Package",
            //     link: "/tenant/tenant-package",
            //     permissions: ["admin", "staf"]
            // },
            {
                text: "Request Package",
                link: "/tenant/request-package",
                permissions: ["admin"]
            }
        ]
    },
    {
        text: "Credit",
        icon: "receipt",
        permissions: ["admin"],
        children: [
            {
                text: "Tenant Credit",
                link: "/credit/tenant-credit",
                permissions: ["admin"]
            },
            {
                text: "Topup Credit",
                link: "/credit/top-up",
                permissions: ["admin"]
            },
            {
                text: "Request Topup Credit",
                link: "/credit/request",
                permissions: ["admin"]
            }
        ]
    },
    {
        text: "Employeer",
        link: "/user",
        icon: "people",
        permissions: ["admin", "staf"]
    },
    {
        text: "Maintenance",
        link: "/maintenance",
        icon: "build",
        permissions: ["admin"]
    },
    {
        text: "User Management",
        link: "/user-management",
        icon: "manage_accounts",
        permissions: ["admin"]
    }
];

const sideNavLowMenus = [
    {
        text: "Settings",
        path: "/settings",
        icon: <i class="material-icons">settings</i>
    },
    {
        text: "About",
        path: "/about",
        icon: <i class="material-icons">error_outlined</i>
    }
];

const color = {
    primary: "#343BF5",
    darkGrey: "#1E2B3D",
    secondary: "#0F6D5E",
    lightGrey: "",
    white: "",
    black: ""
};

const fontSize = {
    f24: "24px",
    f14: "14px",
    f12: "12px",
    f10: "10px"
};

export { sideNavLowMenus, color, items, fontSize };